/* eslint import/prefer-default-export: 0 */

const lazyCmpConfig = {
  loading: {
    template: "<div>Async loading!</div>"
  },
  error: {
    template: "<div>ERROR loading!</div>"
  },
  delay: 200,
  timeout: 10000
};

export const DashboardIndex = () => ({
  component: import("@/itrain/components/sections/dashboard/DashboardIndex/index"),
  ...lazyCmpConfig
});

// /

export const CourseList = () => ({
  component: import("@/itrain/components/sections/courses/CourseList/index"),
  ...lazyCmpConfig
});

export const CreateCourse = () => ({
  component: import("@/itrain/components/sections/courses/CreateCourse/index"),
  ...lazyCmpConfig
});

export const EditCourse = () => ({
  component: import("@/itrain/components/sections/courses/EditCourse/index"),
  ...lazyCmpConfig
});

export const CourseReport = () => ({
  component: import("@/itrain/components/sections/courses/CourseReport/index"),
  ...lazyCmpConfig
});

///

export const ProgramList = () => ({
  component: import("@/itrain/components/sections/programs/ProgramList/index"),
  ...lazyCmpConfig
});

export const CreateProgram = () => ({
  component: import("@/itrain/components/sections/programs/CreateProgram/index"),
  ...lazyCmpConfig
});

export const EditProgram = () => ({
  component: import("@/itrain/components/sections/programs/EditProgram/index"),
  ...lazyCmpConfig
});

export const ProgramReport = () => ({
  component: import("@/itrain/components/sections/programs/ProgramReport/index"),
  ...lazyCmpConfig
});

export const CoursesReport = () => ({
  component: import("@/itrain/components/sections/reports/CoursesReport/index"),
  ...lazyCmpConfig
});

export const UsersReport = () => ({
  component: import("@/itrain/components/sections/reports/UsersReport/index"),
  ...lazyCmpConfig
});

export const UsersList = () => ({
  component: import("@/itrain/components/sections/reports/UsersList/index"),
  ...lazyCmpConfig
});

export const NotificationSearch = () => ({
  component: import("@/itrain/components/sections/notifications/Search/index"),
  ...lazyCmpConfig
});
